import { CompanySelector } from './CompanySelector';

export { CompanySelector };

export const MANUAL_ORG_NUMBER = 'manuell';
